// import React from "react";
// import './SocialButtons.css';

// export default function SocialButtons() {
//   const socialLinks = [
//     {
//         name: "WhatsApp",
//         url: "https://api.whatsapp.com/send?phone=919022554999&text=Hi,%20I%20want%20to%20know%20about%20Gym%20Arena!&lang=en",
//         color: "#25D366",
//         icon: "fab fa-whatsapp",
//       },
//       {
//         name: "Facebook",
//         url: "https://www.facebook.com/yourpage",
//         color: "#1877F2",
//         icon: "fab fa-facebook-f",
//       },
//       {
//         name: "Instagram",
//         url: "https://www.instagram.com/yourpage",
//         color: "#E1306C",
//         icon: "fab fa-instagram",
//       },
//   ];

//   return (
//     <div className="social-buttons">
//       {socialLinks.map((social) => (
//         <button
//           key={social.name}
//           style={{ backgroundColor: social.color }}
//           className="social-button"
//           onClick={() => window.open(social.url, "_blank")}
//         >
//           {social.icon}
//         </button>
//       ))}
//     </div>
//   );
// }

import React from "react";
import './SocialButtons.css';

export default function SocialButtons() {
  const socialLinks = [
    {
      name: "WhatsApp",
      url: "https://api.whatsapp.com/send?phone=919022554999&text=Hi,%20I%20want%20to%20know%20about%20Gym%20Arena!&lang=en",
      color: "#25D366",
      icon: "fab fa-whatsapp",
    },
    {
      name: "Facebook",
      url: "https://www.facebook.com/gym.arenaa.12?rdid=YLUatLPGsfmiWP5W&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1CP5TfkKE8%2F#",
      color: "#1877F2",
      icon: "fab fa-facebook-f",
    },
    {
      name: "Instagram",
      url: "https://www.instagram.com/gymarenaaforever?igsh=MXcyeHZpdzdyemkzag%3D%3D",
      color: "#E1306C",
      icon: "fab fa-instagram",
    },
  ];

  return (
    <div className="social-buttons">
      {socialLinks.map((social) => (
        <button
          key={social.name}
          style={{ backgroundColor: social.color }}
          className="social-button"
          onClick={() => window.open(social.url, "_blank")}
        >
          <i className={social.icon}></i>
        </button>
      ))}
    </div>
  );
}